module.exports = __webpack_public_path__ + "staticVue/img/arrow.059fd305.png";